export const AppRoute = {
  MainPage: "/",
  NotFound: "*",
  News: "/newslist",
  ProductComparison: "/productcomparison",
  // Rosseti: "/Rosseti",
  ACM: "/ACM",
  Transneft: "/Transneft",
  Lenenergo: "/Lenenergo",
  RZA: "/RZA",
  Partners: "/Partners",
  NewsItem: "/news/:id",
  ElectricPower: "/electricpower",
  MiningIndustry: "/miningindustry",
  ManufacturingIndustry: "/manufacturingindustry",
  Production: "/Production",
  TimeAttendanceSystem: "/Time&AttendanceSystem",
  Telecommunication: "/TelecommunicationAsetsAccountingSystem",
  EnergyFacilities: "/AutomationSystemForDesigningWindEnergyFacilities",
  //tech
  // Build: "/Build",
  // Dm: "/Dm",
  // Docs: "/Docs",
  // Edu: "/Edu",
  // Eqgen: "/Eqgen",
  // Eqhv: "/Eqhv",
  // Eqmv: "/Eqmv",
  // Gis: "/Gis",
  // Maintanance: "/Maintanance",
  // Metering: "/Metering",
  // Opt: "/Opt",
  // Oscl: "/Oscl",
  // Pf: "/Pf",
  // Rpa: "/Rpa",
  // Sc: "/Sc",
  // Se: "/Se",
  // Uml: "/Uml",
  //plugins
  // DeveloperPlugin: "/developerPlugin",
  // VectorPlugin: "/vectorPlugin",
  // ScadaPlugin: "/scadaPlugin",
  // MessagePlugin: "/messagePlugin",
  // MapPlugin: "/mapPlugin",
  // OscilloscopePlugin: "/oscilloscopePlugin",
  // VideoPlugin: "/videoPlugin",
  // DashboardPlugin: "/dashboardPlugin",
  TestProgramsAndMethods: "/testProgramsAndMethods",
  TechnicalSupport: "/technicalSupport",
  TechnicalRequirements: "/technicalRequirements",
  ScientificDevelopmentAndResearch: "/scientificDevelopmentAndResearch",
  ProjectDocumentation: "/projectDocumentation",
  OperationalDocumentation: "/operationalDocumentation",
  Implementation: "/Implementation",
  SurveyReport: "/SurveyReport",
  DemoForm: "/DemoForm",
  //components
  SwitchBlanck: "switchBlanck",
  AndroidVersion: "androidVersion",
  StateMonitor: "stateMonitor",
  Transmission60870: "transmission60870",
  Transmission61850: "transmission61850",
  CronTask: "crontask",
  ConnectDevice61850: "connectDevice61850",
  ConnectDevice61850: "connectDevice61850",
  DesktopApplication: "desktopApplication",
  MultimonitorApplication: "multimonitorApplication",
  TouchPanelApplication: "touchpanelapplication",
  NPTMobile: "nptmobile",
  IED: "IED",
  RPAMonitor: "rpamonitor",
  TrafficAnalyzer: "trafficanalyzer",
  ReportBuilder: "reportbuilder",
  IEC61131: "iec61131",
  IEC61850Server: "iec61850server",
  IEC61850Client: "iec61850client",
  IEC608705104Server: "iec608705104server",
  SMTPClient: "smtpclient",
  MQTTClient: "mqttclient",
  RabbitMQClient: "rabbitmqclient",
  KafkaClient: "kafkaclient",
  SNMPClient: "SNMPClient",
  ODBCClient: "odbcclient",
  OscilloscopePlugin: "oscilloscopePlugin",
  MapPlugin: "mapPlugin",
  VideoPlugin: "videoPlugin",
  TopologyAnalysis: "topologyAnalysis",
  ModeCalculation: "modeCalculation",
  StateEstimation: "stateEstimation",
  SCCalulation: "SCCalulation",
  DispatcherSimulator: "dispatcherSimulator",
  //Implementations
  IntegRPAMonitor: "rpamonitorintegration",
  IntegTrafficAnalyzer: "trafficanalyzerintegration",
  IntegWEBSCADA: "webscadaintegration",
  IntegIntelectualSCADA: "intellectualscadaintegration",
  SwitchingBlankEditor: 'switchingblankeditor',
  OPCUAClient: 'opcuaclient',
  OPCUAServer: 'opcuaserver',
};

export const news = [
  {
    title: `SCADA NPT Compact внесена в реестр российского ПО: новый шаг в развитии отечественных технологий `,
    data: "14.12.2020",
    id: 1,
    page: `Мы рады сообщить Вам, что система управления и сбора данных SCADA NPT Compact успешно внесена в единый реестр российских программ для электронных вычислительных машин и баз данных. Решение о включении было принято Министерством цифрового развития, связи и массовых коммуникаций Российской Федерации.

SCADA NPT Compact — это современная система для автоматизации, мониторинга и управления технологическими процессами. Ее включение в реестр подтверждает соответствие требованиям российского законодательства и подчеркивает важность развития отечественных IT-решений в условиях импортозамещения. С внесением в реестр система станет еще более доступной для широкого круга предприятий, способствуя цифровой трансформации промышленности России.
    
ГК "ЭнергопромАвтоматизация", разработчик SCADA NPT Compact, продолжает совершенствовать систему, ориентируясь на потребности рынка и актуальные вызовы в области автоматизации и цифровизации.

Благодарим за ваше внимание к нашей системе. Попробуйте [SCADA NPT Compact](https://epsa-spb.ru/kontakty-2/) и оцените ее возможности уже сегодня!  

[Реестровая запись №7701](https://reestr.digital.gov.ru/reestr/309051/) от 14.12.2020`,
    image: 'minsvyazi.png',
  },
  {
    title: `АСМ РЗА NPT RPA Monitor включен в реестр российского ПО: новый этап развития отечественных решений для энергетики и промышленности`,
    data: "28.10.2024",
    id: 2,
    page: `Мы рады сообщить Вам, что автоматизированная система мониторинга устройств релейной защиты и автоматики (АСМ РЗА) NPT RPA Monitor официально внесена в единый реестр российских программ для электронных вычислительных машин и баз данных. Решение о включении принято Министерством цифрового развития, связи и массовых коммуникаций Российской Федерации.

[NPT RPA Monitor](/${AppRoute.RPAMonitor}) — это инновационная система, предназначенная для мониторинга, диагностики и анализа работы устройств релейной защиты и автоматики. Ее включение в реестр подтверждает соответствие системы требованиям российского законодательства и подчеркивает ее значимость для цифровизации энергетической инфраструктуры страны.
    
ГК "ЭнергопромАвтоматизация", разработчик NPT RPA Monitor, продолжает совершенствовать систему, ориентируясь на потребности рынка и современные вызовы в области автоматизации и цифровизации энергетики и других стратегически важных отраслей.

Благодарим за ваше внимание к нашей системе. Попробуйте [NPT RPA Monitor](https://epsa-spb.ru/kontakty-2/) и оцените его возможности уже сегодня!  

[Реестровая запись №24588](https://reestr.digital.gov.ru/reestr/2757888/) от 28.10.2024`,
    image: 'minsvyazi.png',
  },
  {
    title: `Анализатор трафика NPT Traffic Analyzer включен в реестр российского ПО: новый инструмент для контроля сетей энергетических объектов`,
    data: "27.11.2024",
    id: 3,
    page: `Мы рады сообщить Вам, что анализатор трафика NPT Traffic Analyzer внесен в единый реестр российских программ для электронных вычислительных машин и баз данных. Решение о включении принято Министерством цифрового развития, связи и массовых коммуникаций Российской Федерации.

[NPT Traffic Analyzer](/${AppRoute.TrafficAnalyzer}) — это специализированное решение, предназначенное для проверки параметров локальной вычислительной сети электрической подстанции, а также анализа сообщений, передаваемых по сети, на соответствие файлам настройки и международному стандарту МЭК 61850. Включение системы в реестр подтверждает ее соответствие требованиям российского законодательства и подчеркивает важность разработки отечественных решений для цифровизации энергетической отрасли.
    
ГК "ЭнергопромАвтоматизация", разработчик NPT Traffic Analyzer, продолжает совершенствовать продукт, ориентируясь на потребности энергетической отрасли и современные вызовы в области цифровой трансформации.

Благодарим за ваше внимание к нашей системе. Попробуйте [NPT Traffic Analyzer](https://epsa-spb.ru/kontakty-2/) и оцените его возможности уже сегодня!  

[Реестровая запись №24946](https://reestr.digital.gov.ru/reestr/2839897/) от 27.11.2024`,
    image: 'minsvyazi.png',
  },


];

export const code = `
<table xmlns="http://npt-platform.com/table" id="substationTable">
  <source>
    <finder classList="cim:Substation" pageable="true">      
    </finder>
  </source>
  <header>
      <column label="Административно-территориальная единица" field="region" path="cim:Substation.Region.cim.IdentifiedObject.name" filter-strategy="string"></column>
      <column label="Наименование ПС" field="label" path="cim:IdentifiedObject.name" filter-strategy="string"></column>
      <column label="Распределительные устройства" field="voltageLevel" path="cim:Substation.VoltageLevels.cim.IdentifiedObject.name" filter-strategy="string"></column>
  </header>
</table>
`;

export const code2 = `
  var query = require('query');
  var table = require('table');

  table.select(function(request) {
    var qb = query.instanceOf('cim:Substation')
    .join("voltageLevel", "cim:Substation.VoltageLevels")
    .equal('voltageLevel[cim.IdentifiedObject.name]', 'ОРУ 500 кВ')  
    return qb;
  });
`;

export const code3 = `
<tree xmlns="http://npt-platform.com/tree" id="registry">
  <branch id="GR" select="cim:GeographicalRegion" icon="npt-i-electrical-unit" icon-color="#418FDE">      
    <add id="addSGR" class="cim:SubGeographicalRegion" parent-ref="cim:SubGeographicalRegion.Region"/>
    <branch id="SGR" select="cim:SubGeographicalRegion" icon="npt-i-eg-alter" icon-color="#FFBE33">
      <add id="addSubstation" class="cim:Substation" parent-ref="cim:Substation.Region"/>      
      <branch id="Substation" select="cim:Substation" icon="npt-i-ps" icon-color="#228B22"></branch> 
    </branch> 
  </branch> 
</tree>
`;

export const code4 = `
"toolbar": [
  {
    "id": "export",
    "type": "group",
    "label": "Экспорт",     
    "group": [
      {
        "id": "exportSubjectsProfile",
        "label": "Экспорт профиля субъектов ПС"
      },
      {
        "id": "exportSubjectsModel",
        "label": "Экспорт субъектов ПС"
      }            
    ]
  },        
  {
    "id": "Reports",
    "type": "button",
    "label": "Отчеты"
  }
]
`;

export const code5 = `
"content": [
  {
    "ui": "grid-cell",
    "content": [
      {
      "ui": "predicate-placeholder",
      "ref": "cim:IdentifiedObject.name"
      },
      {
      "ui": "predicate-placeholder",
      "ref": "cim:IdentifiedObject.mRID",
      "options": {
        "label": "Идентификатор в мастер системе"
        }
      },
      {
        "ui": "predicate-placeholder",
        "ref": "cim:Substation.Region"
      }
    ]
  }
]
`;

export const code6 = `
var query = require('query');
var model = require('model');

model.build('substationModel', 'rdf/xml', function() {
  return model
    .over(query.instanceOf(
    'cim:Substation', 
    'cim:PowerSystemResource', 
    'cim:TransformerEnd'
  ) .primitives(true)
    .subjectRelations(true)
});
`;

export const code7 = `
var files = require('files');
var printRDF = require('print').printRDF;

var adapter = files.loadRDFModel('model.rdf');
var profile = files.loadXSDProfile('profile.xsd');
adapter.setProfile(profile);

printRDF(adapter);
`;

export const technicalSolutionsLinks = [
  {
    title: "NPT RPA Monitor",
    link: AppRoute.RPAMonitor,
  },
  {
    title: "NPT Traffic Analyzer",
    link: AppRoute.TrafficAnalyzer,
  },
  // {
  //   title: "NPT Intelligent End Device",
  //   link: AppRoute.IED,
  // },
];

technicalSolutionsLinks.sort((a, b) => a.title.localeCompare(b.title));

export const implementationExamples = [
  {
    title: "Web-SCADA (SCADA NPT Compact)",
    link: AppRoute.IntegWEBSCADA,
  },
  {
    title: "АСМ РЗА (NPT RPA Monitor)",
    link: AppRoute.IntegRPAMonitor,
  },
  {
    title: "Регистратор событий ЦПС (NPT Traffic Analyzer)",
    link: AppRoute.IntegTrafficAnalyzer,
  },

  {
    title: "Интеллектуальная система учета (SCADA NPT Compact)",
    link: AppRoute.IntegIntelectualSCADA,
  },
];


export const pluginsLinks = [
  {
    list: [
      {
        title: "Клиенты",
        list: [
          {
            title: "Приложение для сенсорных панелей",
            link: AppRoute.TouchPanelApplication,
          },
          {
            title: "Приложение для мобильных устройств",
            link: AppRoute.NPTMobile,
          },
        ],
      },
      {
        title: "Автоматизация и логическая обработка",
        list: [
          {
            title: "Конструктор отчетов",
            link: AppRoute.ReportBuilder,
          },
          {
            title: "МЭК 61131",
            link: AppRoute.IEC61131,
          },
          {
            title: "Периодические задачи",
            link: AppRoute.CronTask,
          },
          {
            title: "Редактор бланков переключений",
            link: AppRoute.SwitchingBlankEditor,
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        title: "Протоколы передачи данных",
        list: [
          {
            title: "МЭК 61850 Клиент",
            link: AppRoute.IEC61850Client,
          },
          {
            title: "МЭК 61850 Сервер",
            link: AppRoute.IEC61850Server,
          },
          {
            title: "МЭК 60870-5-104 Сервер",
            link: AppRoute.IEC608705104Server,
          },
          {
            title: "MQTT Клиент",
            link: AppRoute.MQTTClient,

          },
          {
            title: "RabbitMQ Клиент",
            link: AppRoute.RabbitMQClient,

          },
          {
            title: "Kafka Клиент",
            link: AppRoute.KafkaClient,

          },
          {
            title: "SMTP Клиент",
            link: AppRoute.SMTPClient,
          },
          {
            title: "ODBC Клиент",
            link: AppRoute.ODBCClient,
          },
          {
            title: "OPC UA Клиент",
            link: AppRoute.OPCUAClient,
          },
          {
            title: "OPC UA Сервер",
            link: AppRoute.OPCUAServer,
          },
        ],
      },

    ],
  },
];
